var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testPaper"},[_c('div',{staticClass:"testPaperWrap"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.detail.paperTitle))]),_c('div',{staticClass:"testDetail"},[_c('span',[_vm._v("试题数量："+_vm._s(_vm.detail.questionTotal)+"道")]),_c('span',{staticClass:"testTime"},[_vm._v("考试时间："+_vm._s(_vm.detail.examDurationTime)+"分钟")]),_c('span',[_vm._v("满分："+_vm._s(_vm.detail.fullScore)+"分")])])]),_c('div',{staticClass:"footer"},[(_vm.num !== 0)?_c('el-button',{staticClass:"signListUp",on:{"click":_vm.signListUp}},[_vm._v("上一题")]):_vm._e(),(_vm.num + 1 !== _vm.list.length)?_c('el-button',{staticClass:"signListNext",on:{"click":_vm.signListNext}},[_vm._v("下一题")]):_vm._e(),(_vm.num + 1 == _vm.list.length)?_c('el-button',{staticClass:"signListNext",on:{"click":_vm.submit}},[_vm._v("交卷")]):_vm._e()],1),_c('div',{staticClass:"quertionWrap"},[_c(_vm.questionComponentMap[_vm.list[_vm.num].questionType - 1],{tag:"component",attrs:{"data":_vm.list[_vm.num],"num":_vm.num,"all-arr":_vm.detail.questionList}})],1)]),_c('div',{staticClass:"right"},[_c('div',{staticClass:"rightTop"},[_c('div',[_vm._v("距考试结束")]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.timenow))])]),_c('div',{staticClass:"rightContent"},[(_vm.single.length > 0)?_c('div',{staticClass:"testBox"},[_c('div',{staticClass:"testType"},[_vm._v("单选题")]),_vm._l((_vm.single),function(item,index){return _c('div',{key:index,staticClass:"choiceItem",class:[
              { nowActive: _vm.num == index },
              {
                choiceActive:
                  item[
                    ['signListRadio', '', '', 'judgeListRadio'][
                      item.questionType - 1
                    ]
                  ] !== '',
              } ],on:{"click":function($event){return _vm.answerCard(index)}}},[_vm._v(" "+_vm._s(index + 1)+" ")])})],2):_vm._e(),(_vm.multiple.length > 0)?_c('div',{staticClass:"testBox"},[_c('div',{staticClass:"testType"},[_vm._v("多选题")]),_vm._l((_vm.multiple),function(item,index){return _c('div',{key:index,staticClass:"choiceItem",class:[
              { nowActive: _vm.num == index + _vm.single.length },
              {
                choiceActive: item.checkbox.length !== 0,
              } ],on:{"click":function($event){return _vm.answerCard(index + _vm.single.length)}}},[_vm._v(" "+_vm._s(index + 1 + _vm.single.length)+" ")])})],2):_vm._e(),(_vm.calculation.length > 0)?_c('div',{staticClass:"testBox"},[_c('div',{staticClass:"testType"},[_vm._v("计算题")]),_vm._l((_vm.calculation),function(item,index){return _c('div',{key:index,staticClass:"choiceItem",class:[
              {
                nowActive: _vm.num == index + _vm.single.length + _vm.multiple.length,
              },
              {
                choiceActive:
                  item.optionList.filter(function (v) { return v.answer; }).length ==
                  item.optionList.length,
              } ],on:{"click":function($event){return _vm.answerCard(index + _vm.single.length + _vm.multiple.length)}}},[_vm._v(" "+_vm._s(index + 1 + _vm.single.length + _vm.multiple.length)+" ")])})],2):_vm._e(),(_vm.judgeList.length > 0)?_c('div',{staticClass:"testBox"},[_c('div',{staticClass:"testType"},[_vm._v("判断题")]),_vm._l((_vm.judgeList),function(item,index){return _c('div',{key:index,staticClass:"choiceItem",class:[
              {
                nowActive:
                  _vm.num ==
                  index +
                    _vm.single.length +
                    _vm.multiple.length +
                    _vm.calculation.length,
              },
              {
                choiceActive:
                  item[
                    ['signListRadio', '', '', 'judgeListRadio'][
                      item.questionType - 1
                    ]
                  ] !== '',
              } ],on:{"click":function($event){return _vm.answerCard(
                index + _vm.single.length + _vm.multiple.length + _vm.calculation.length
              )}}},[_vm._v(" "+_vm._s(index + 1 + _vm.single.length + _vm.multiple.length + _vm.calculation.length)+" ")])})],2):_vm._e(),(_vm.completion.length > 0)?_c('div',{staticClass:"testBox"},[_c('div',{staticClass:"testType"},[_vm._v("填空题")]),_vm._l((_vm.completion),function(item,index){return _c('div',{key:index,staticClass:"choiceItem",class:[
              {
                nowActive:
                  _vm.num ==
                  index +
                    _vm.single.length +
                    _vm.multiple.length +
                    _vm.calculation.length +
                    _vm.judgeList.length,
              },
              {
                choiceActive:
                  item.optionList.filter(function (v) { return v.answer; }).length ==
                  item.optionList.length,
              } ],on:{"click":function($event){return _vm.answerCard(
                index +
                  _vm.single.length +
                  _vm.multiple.length +
                  _vm.calculation.length +
                  _vm.judgeList.length
              )}}},[_vm._v(" "+_vm._s(index + 1 + _vm.single.length + _vm.multiple.length + _vm.calculation.length + _vm.judgeList.length)+" ")])})],2):_vm._e(),(_vm.shortAnswer.length > 0)?_c('div',{staticClass:"testBox"},[_c('div',{staticClass:"testType"},[_vm._v("简答题")]),_vm._l((_vm.shortAnswer),function(item,index){return _c('div',{key:index,staticClass:"choiceItem",class:[
              {
                nowActive:
                  _vm.num ==
                  index +
                    _vm.single.length +
                    _vm.multiple.length +
                    _vm.calculation.length +
                    _vm.judgeList.length +
                    _vm.completion.length,
              },
              {
                choiceActive:
                  item.optionList.filter(function (v) { return v.answer; }).length ==
                  item.optionList.length,
              } ],on:{"click":function($event){return _vm.answerCard(
                index +
                  _vm.single.length +
                  _vm.multiple.length +
                  _vm.calculation.length +
                  _vm.judgeList.length +
                  _vm.completion.length
              )}}},[_vm._v(" "+_vm._s(index + 1 + _vm.single.length + _vm.multiple.length + _vm.calculation.length + _vm.judgeList.length + _vm.completion.length)+" ")])})],2):_vm._e(),(_vm.discuss.length > 0)?_c('div',{staticClass:"testBox"},[_c('div',{staticClass:"testType"},[_vm._v("论述题")]),_vm._l((_vm.discuss),function(item,index){return _c('div',{key:index,staticClass:"choiceItem",class:[
              {
                nowActive:
                  _vm.num ==
                  index +
                    _vm.single.length +
                    _vm.multiple.length +
                    _vm.calculation.length +
                    _vm.judgeList.length +
                    _vm.completion.length +
                    _vm.shortAnswer.length,
              },
              {
                choiceActive:
                  item.optionList.filter(function (v) { return v.answer; }).length ==
                  item.optionList.length,
              } ],on:{"click":function($event){return _vm.answerCard(
                index +
                  _vm.single.length +
                  _vm.multiple.length +
                  _vm.calculation.length +
                  _vm.judgeList.length +
                  _vm.completion.length +
                  _vm.shortAnswer.length
              )}}},[_vm._v(" "+_vm._s(index + 1 + _vm.single.length + _vm.multiple.length + _vm.calculation.length + _vm.judgeList.length + _vm.completion.length + _vm.shortAnswer.length)+" ")])})],2):_vm._e(),(_vm.caseAnalysis.length > 0)?_c('div',{staticClass:"testBox"},[_c('div',{staticClass:"testType"},[_vm._v("案列分析题")]),_vm._l((_vm.caseAnalysis),function(item,index){return _c('div',{key:index,staticClass:"choiceItem",class:[
              {
                nowActive:
                  _vm.num ==
                  index +
                    _vm.single.length +
                    _vm.multiple.length +
                    _vm.calculation.length +
                    _vm.judgeList.length +
                    _vm.completion.length +
                    _vm.shortAnswer.length +
                    _vm.discuss.length,
              },
              {
                choiceActive:
                  item.optionList.filter(function (v) { return v.answer; }).length ==
                  item.optionList.length,
              } ],on:{"click":function($event){return _vm.answerCard(
                index +
                  _vm.single.length +
                  _vm.multiple.length +
                  _vm.calculation.length +
                  _vm.judgeList.length +
                  _vm.completion.length +
                  _vm.shortAnswer.length +
                  _vm.discuss.length
              )}}},[_vm._v(" "+_vm._s(index + 1 + _vm.single.length + _vm.multiple.length + _vm.calculation.length + _vm.judgeList.length + _vm.completion.length + _vm.shortAnswer.length + _vm.discuss.length)+" ")])})],2):_vm._e(),(_vm.comprehensive.length > 0)?_c('div',{staticClass:"testBox"},[_c('div',{staticClass:"testType"},[_vm._v("综合题")]),_vm._l((_vm.comprehensive),function(item,index){return _c('div',{key:index,staticClass:"choiceItem",class:[
              {
                nowActive:
                  _vm.num ==
                  index +
                    _vm.single.length +
                    _vm.multiple.length +
                    _vm.calculation.length +
                    _vm.judgeList.length +
                    _vm.completion.length +
                    _vm.shortAnswer.length +
                    _vm.discuss.length +
                    _vm.caseAnalysis.length,
              },
              {
                choiceActive:
                  item.optionList.filter(function (v) { return v.answer; }).length ==
                  item.optionList.length,
              } ],on:{"click":function($event){return _vm.answerCard(
                index +
                  _vm.single.length +
                  _vm.multiple.length +
                  _vm.calculation.length +
                  _vm.judgeList.length +
                  _vm.completion.length +
                  _vm.shortAnswer.length +
                  _vm.discuss.length +
                  _vm.caseAnalysis.length
              )}}},[_vm._v(" "+_vm._s(index + 1 + _vm.single.length + _vm.multiple.length + _vm.calculation.length + _vm.judgeList.length + _vm.completion.length + _vm.shortAnswer.length + _vm.discuss.length + _vm.caseAnalysis.length)+" ")])})],2):_vm._e()]),_c('div',{staticClass:"rightFooter"},[_c('div',{staticClass:"submitBtn",on:{"click":_vm.submit}},[_vm._v("交卷")])])])]),_c('dialogType',{ref:"dialogType"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }